import { sfRest, sfQuery } from "../API";

export const getTeams = async (context) => {
  const result = await sfRest(
    "Teams",
    "GARGLEAnalytics",
    "Teams",
    {
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByVP: null,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getVP = async (context) => {
  const result = await sfRest(
    "VP",
    "GARGLEAnalytics",
    "VP",
    {
      FilterByOwner: null,
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getSocialPlus = async (context) => {
  const result = await sfRest(
    "SocialPlus",
    "GARGLEAnalytics",
    "SocialPlus",
    {
      FilterByVP: null,
      FilterByOwner: null,
      FilterBySocialAdSpecialist:
        context.SocialAdSpecialistId === "null"
          ? null
          : context.SocialAdSpecialistId,
    },
    context
  );
  return result;
};

export const getWebsite = async (context) => {
  const result = await sfRest(
    "Website",
    "GARGLEAnalytics",
    "Website",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getPPC = async (context) => {
  const result = await sfRest(
    "PPC",
    "GARGLEAnalytics",
    "PPC",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );

  return result;
};

export const getSEO = async (context) => {
  const result = await sfRest(
    "SEO",
    "GARGLEAnalytics",
    "SEO",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getSocialMedia = async (context) => {
  const result = await sfRest(
    "SocialMediaContent",
    "GARGLEAnalytics",
    "SocialMediaContent",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getAudit = async (context) => {
  const result = await sfRest(
    "Audit",
    "GARGLEAnalytics",
    "Audit",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getContent = async (context) => {
  const result = await sfRest(
    "Content",
    "GARGLEAnalytics",
    "Content",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getDirectors = async (context) => {
  const result = await sfRest(
    "Directors",
    "GARGLEDirectors",
    "Directors",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getCompletedDirAccRw = async (context) => {
  const result = await sfRest(
    "CompletedDirAccRw",
    "GARGLEDirectors",
    "CompletedDirAccRw",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getLastVPContactTable = async (context) => {
  const result = await sfRest(
    "LastVPContactTable",
    "GARGLEDirectors",
    "LastVPContactTable",
    {
      FilterByVP: null,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getVPsDashboard = async (context) => {
  const result = await sfRest(
    "VP",
    "GARGLEDirectors",
    "VP",
    {
      FilterByOwner: null,
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getWebsiteDashboard = async (context) => {
  const result = await sfRest(
    "Website",
    "GARGLEDirectors",
    "Website",
    {
      FilterByOwner: null,
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getCoordinatorsDashboard = async (context) => {
  // Initialize the result object with the same structure as the Apex class
  const result = {
    TotalGM: { CountAcc: 0 },
    CallPreps: { Red: 0, Yellow: 0, Green: 0 },
    CallPrepsLast7Days: { Green: 0 },
    AccwAudits: { Red: 0, Green: 0 },
    AuditsThisWeek: { Green: 0 },
    AuditsThisMonth: { Green: 0 },
    CompletedDirectorAccountReviews: { Red: 0, Green: 0 },
    CompletedVPSemiAnnualReviews: { Red: 0, Green: 0 },
    OverdueTasks: { Red: 0, Green: 0 },
    NoOpenActivities: { Red: 0, Green: 0 },
    CompletionOfSAItasks: { Red: 0, Yellow: 0, Green: 0 },
    OverdueInvoices: { Red: 0, Green: 0 },
    ExpiringDiscounts: { Red: 0, Green: 0 },
    PausedPorducts: { Red: 0, Green: 0 },
    BurstAccelerators: { Red: 0, Green: 0 },
    DMOnlyReport: { Green: 0 },
    GMOnlyReport: { Green: 0 },
    TotalTasksDueToday: { Count: 0 },
    AccountsByProduct: {},
    TasksCompletedThisWeek: 0,
    TasksCompletedThisMonth: 0,
  };

  // Get active memberships count
  const activeMemberships = await sfQuery(
    "Account",
    "Id",
    `Membership_Status__c = 'Activated' AND (NOT Account.Name LIKE 'Test %') AND RecordType.Name = 'Customer'`,
    context
  );
  result.TotalGM.CountAcc = activeMemberships.length;

  // Get call preps
  const callPreps = await sfQuery(
    "Task",
    "Id, WhatId, ActivityDate, Status, CompletedDateTime, OwnerId, Owner.Name, Number_of_Locations__c",
    `Task_Type__c IN ('Prep', 'DAR Prep', 'BR Prep') AND ActivityDate <= NEXT_N_WEEKS:2 AND ActivityDate >= LAST_N_WEEKS:3 AND (NOT Owner.Name LIKE 'Abby%') AND (NOT Owner.Name LIKE 'Hannah%')`,
    context
  );

  // Get DAR tasks
  const darTasks = await sfQuery(
    "Task",
    "Id, WhatId, ActivityDate, Status, CompletedDateTime, OwnerId, Owner.Name, Number_of_Locations__c",
    `Task_Type__c IN ('DAR', 'Director 30-Day New Client Call') AND ActivityDate <= NEXT_WEEK AND ActivityDate >= LAST_WEEK`,
    context
  );

  // Process call preps and DAR tasks
  const lastScheduledDarPerClient = new Map();
  callPreps.forEach((task) => {
    if (!lastScheduledDarPerClient.has(task.WhatId)) {
      lastScheduledDarPerClient.set(task.WhatId, task);
    }
  });

  const iteratedAccountsScheduledDAR = new Set();
  darTasks.forEach((task) => {
    if (!iteratedAccountsScheduledDAR.has(task.WhatId)) {
      iteratedAccountsScheduledDAR.add(task.WhatId);
      const numOfLocations = task.Number_of_Locations__c || 1;

      if (lastScheduledDarPerClient.has(task.WhatId)) {
        const prepTask = lastScheduledDarPerClient.get(task.WhatId);
        const daysBetween = getBusinessDaysBetween(
          prepTask.ActivityDate,
          task.ActivityDate
        );

        if (prepTask.ActivityDate < new Date() && prepTask.Status === "Open") {
          result.CallPreps.Red += numOfLocations;
        } else if (daysBetween <= -1) {
          result.CallPreps.Green += numOfLocations;
        } else if (daysBetween === 0) {
          result.CallPreps.Yellow += numOfLocations;
        } else {
          result.CallPreps.Red += numOfLocations;
        }
      } else {
        result.CallPreps.Red += numOfLocations;
      }
    }
  });

  // Get call preps last 7 days
  const callPrepsLast7Days = await sfQuery(
    "Call_Prep__c",
    "Id",
    "CreatedDate = LAST_N_DAYS:7",
    context
  );
  result.CallPrepsLast7Days.Green = callPrepsLast7Days.length;

  // Get audits this month
  const auditsThisMonth = await sfQuery(
    "Task",
    "Id, WhatId",
    `Status = 'Completed' AND ActivityDate = THIS_MONTH AND Task_Type__c = 'Account Audit' AND (NOT What.Name LIKE 'Test %')`,
    context
  );
  result.AuditsThisMonth.Green = auditsThisMonth.length;

  // Get overdue tasks
  const overdueTasks = await sfQuery(
    "Task",
    "Id",
    `Status = 'Open' AND ActivityDate < TODAY AND WhatId IN (SELECT Id FROM Account WHERE Membership_Status__c = 'Activated')`,
    context
  );
  result.OverdueTasks.Red = overdueTasks.length;

  // Get accounts with no open activities
  const accountsWithNoOpenActivities = await sfQuery(
    "Account",
    "Id, (SELECT Id FROM Tasks WHERE Status = 'Open')",
    `Membership_Status__c = 'Activated'`,
    context
  );
  result.NoOpenActivities.Red = accountsWithNoOpenActivities.filter(
    (account) => account.Tasks.records.length === 0
  ).length;

  // Get overdue invoices
  const overdueInvoices = await sfQuery(
    "Order",
    "Id",
    `Account.Membership_Status__c = 'Activated' AND Order_Label__c LIKE 'MI-%' AND Payment_Date_new__c < TODAY AND Amount_Owed__c > 0 AND Status = 'Activated'`,
    context
  );
  result.OverdueInvoices.Red = overdueInvoices.length;

  // Get accounts by product
  const accountsByProduct = await sfQuery(
    "OrderItem",
    "PricebookEntry.Product2.Name",
    `Order.Account.Membership_Status__c = 'Activated' AND Order.Order_Label__c LIKE 'GM-%' AND Order.Status IN ('Activated', 'Ala Carte Non Member') AND Is_Active__c = TRUE AND Product_Available__c = TRUE AND Is_Cancelled__c = FALSE AND (NOT Product2.ProductCode IN ('PC', 'DMPC', 'NM', 'DMNM', 'RC', 'DMRC'))`,
    context
  );

  accountsByProduct.forEach((item) => {
    const product = item.PricebookEntry.Product2.Name || "Unknown";
    result.AccountsByProduct[product] =
      (result.AccountsByProduct[product] || 0) + 1;
  });

  // Get tasks completed this week/month
  const tasksCompletedThisWeek = await sfQuery(
    "Task",
    "Id",
    `Status = 'Completed' AND CompletedDateTime = THIS_WEEK`,
    context
  );
  result.TasksCompletedThisWeek = tasksCompletedThisWeek.length;

  const tasksCompletedThisMonth = await sfQuery(
    "Task",
    "Id",
    `Status = 'Completed' AND CompletedDateTime = THIS_MONTH`,
    context
  );
  result.TasksCompletedThisMonth = tasksCompletedThisMonth.length;

  return result;
};

// Helper function to calculate business days between two dates
const getBusinessDaysBetween = (startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  let count = 0;
  const curDate = new Date(start.getTime());
  while (curDate <= end) {
    const dayOfWeek = curDate.getDay();
    if (dayOfWeek !== 0 && dayOfWeek !== 6) count++;
    curDate.setDate(curDate.getDate() + 1);
  }
  return count;
};

export const getProfitabilityDashboard = async (context) => {
  const result = await sfRest(
    "Profitability",
    "GARGLEDirectors",
    "Profitability",
    {
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByVP: null,
      FilterBySocialPlus: null,
    },
    context
  );
  return result;
};

export const getCompletedDARCS = async (context) => {
  const result = await sfRest(
    "CompletedDAR",
    "GARGLEDirectors",
    "CompletedDAR",
    {
      FilterByOwner: null,
      FilterByVP: null,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getCompletedVPCS = async (context) => {
  const result = await sfRest(
    "CompletedVP",
    "GARGLEDirectors",
    "CompletedVP",
    {
      FilterByOwner: null,
      FilterByVP: null,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getCallPrepsCS = async (context) => {
  const result = await sfRest(
    "CallPrepsCS",
    "GARGLEDirectors",
    "CallPrepsCS",
    {
      FilterByOwner: null,
      FilterByVP: null,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getCompletedSAICS = async (context) => {
  const result = await sfRest(
    "CompletedSAICS",
    "GARGLEDirectors",
    "CompletedSAICS",
    {
      FilterByOwner: null,
      FilterByVP: null,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getConnectionSEO = async (context) => {
  const result = await sfRest(
    "ConnectionSEO",
    "GARGLEDirectors",
    "ConnectionSEO",
    {
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getConnectionPPC = async (context) => {
  const result = await sfRest(
    "ConnectionPPC",
    "GARGLEDirectors",
    "ConnectionPPC",
    {
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getConnectionSM = async (context) => {
  const result = await sfRest(
    "ConnectionSM",
    "GARGLEDirectors",
    "ConnectionSM",
    {
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getConnectionSP = async (context) => {
  const result = await sfRest(
    "ConnectionSP",
    "GARGLEDirectors",
    "ConnectionSP",
    {
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getOnboardingCT = async (context) => {
  const result = await sfRest(
    "OnboardingCT",
    "GARGLEDirectors",
    "OnboardingCT",
    {
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getWelcomeCT = async (context) => {
  const result = await sfRest(
    "WelcomeCallTimeline",
    "GARGLEDirectors",
    "WelcomeCallTimeline",
    {
      FilterByVP: context.VPId === "null" ? null : context.VPId,
      FilterByOwner: context.OwnerId === "null" ? null : context.OwnerId,
      FilterByCSC: context.CSCId === "null" ? null : context.CSCId,
    },
    context
  );
  return result;
};

export const getStats = async (context, dateFilter) => {
  const result = await sfRest(
    "Stats",
    "GARGLESalesStats",
    "Stats",
    {
      FilterByDate: dateFilter,
    },
    context
  );
  return result;
};
